export default "__VITE_ASSET__DKmYVJqc__"